import { Stack } from '../../../../../design-system/stack/stack';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';
import { EvidenceCard } from './evidence-card';

type EvidenceWrapperProps = {
  evidence: InvoiceEvidenceView[];
  onViewEvidence: (documentId: string) => void;
  onDownloadEvidence: (documentId: string) => void;
};

export const EvidenceWrapper = ({ evidence, onViewEvidence, onDownloadEvidence }: EvidenceWrapperProps) => {
  return (
    <Stack space={4} className="w-full">
      <p className="text-base font-medium leading-[22px] tracking-[-0.02em]">Evidence</p>
      <Stack space={3} className="w-full">
        {evidence.map((evidence) => (
          <EvidenceCard
            key={evidence.id}
            fileName={evidence.document?.fileName ?? 'File Name'}
            documentId={evidence.document?.id ?? ''}
            onViewEvidence={onViewEvidence}
            onDownloadEvidence={onDownloadEvidence}
          />
        ))}
      </Stack>
    </Stack>
  );
};
